import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  Filter,
  TextInput,
  Pagination,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceInput,
  AutocompleteInput,
  AutocompleteArrayInput,
} from "react-admin";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Chip } from "@material-ui/core";
import { getBommedExporter } from '../util/sheet';
import { Actions, Resources, useHasPermissions } from "../lib/react-admin-loopback";

const exporter = getBommedExporter('menu');
/*
const CategoryField = ({ record = {} }) => {
  if (record)  {
    if (record.menuCategory) {
        if (record.menuCategory.indexOf("//") != -1) {
            const cateArr = record.menuCategory.split("//");
            const cateTxt = cateArr.join("<br>");
            return <div dangerouslySetInnerHTML={{ __html: cateTxt }}  />;
        }
        else
        {
            return <div >{record.menuCategory}</div>;
        }
    }
    else
    {
        return <div></div>;
    }
}
}

const SubMenuField = ({ record = {} }) => {
if (record) {
    if (record.subMenu) {
        if (record.subMenu.indexOf("//") != -1) {
            const subMenuArr = record.subMenu.split("//");

            subMenuArr.map(element => {
                return <Chip label={element} /> ;
            })

        }
        else {
            return <Chip label={record.subMenu} />;
        }
    }
    else
    {
        return <div></div>;
    }
}
else
    {
        return <div></div> ;
    }
}*/

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
    },
    bool: {
      width: "100%",
      textAlign: "center",
    },
    supplier: {
      textAlign: "center",
    },
  })
);
const PostFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      perPage={500}
      label="공급자"
      source="supplierId"
      reference="suppliers"
    >
      <AutocompleteInput optionText="name" optionValue="id" resettable />
    </ReferenceInput>
  </Filter>
);

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export const MenuList = (props) => {

  const hasShowPermission = useHasPermissions(
    Resources.Menu,
    Actions.Show,
  );

  const classes = useStyles();

  return (
    <React.Fragment>
      <List
        {...props}
        pagination={<PostPagination />}
        perPage={50}
        filters={<PostFilter />}
        exporter={exporter}
      >
        <Datagrid className={classes.root} 
          rowClick={ hasShowPermission ? "edit" : null } 
          {...props} >
          <TextField source="id" label="id" />
          <ReferenceField
            link={false}
            sortable={false}
            source="supplierId"
            label="공급자"
            reference="suppliers"
          >
            <TextField className={classes.supplier} source="name" />
          </ReferenceField>
          <TextField source="name" label="메뉴명" />
          <TextField
            className={classes.supplier}
            source="subMenu"
            label="서브메뉴"
            sortable={false}
          />
          <TextField
            source="serviceTimeAvailable"
            label="오더가능유형"
            sortable={false}
          />
          <TextField source="ratingFooding" label="별점" />
          <TextField source="packageCount" label="용기수" />
          <TextField source="price" label="단가" />
          <TextField source="orderQtyMin" label="최소수량" />
          <TextField source="orderQtyMax" label="최대수량" />
          <TextField
            source="menuCategory"
            label="카테고리"
            sortable={false}
          ></TextField>
          <ReferenceField
            link={false}
            source="serviceTypeId"
            label="취식형태"
            reference="commonCodes"
          >
            <TextField source="desc" />
          </ReferenceField>
          <ReferenceField
            link={false}
            source="curationGenderId"
            label="태그1"
            reference="commonCodes"
          >
            <TextField source="desc" />
          </ReferenceField>
          <TextField source="curationAge" label="테그2" />
        </Datagrid>
      </List>
    </React.Fragment>
  );
};
export default MenuList;
